import { IWidgetConfigurationProps } from "@sgwt-widget/core";
import { filter, first, get, map } from "lodash";
import { IProps } from "../../salescredit/salescredit-types";
import { InteractiveState } from "./pivot-types";
import { getAllNbiAttributes, getAllNbiKpis } from "./helper";
import {
  getAllAttributes as getAllScAttributes,
  getAllKpis as getAllScKpis,
} from "../../../cpr-salescredit-interactive-chart/utils/helper";

const nbiAattributes = getAllNbiAttributes().map((x: any) => {
  return { id: x.id, name: x.name };
});

const nbiKpis = getAllNbiKpis().map((x: any) => {
  return { id: x.id, name: x.name };
});

const scAattributes = getAllScAttributes().map((x: any) => {
  return { id: x.id, name: x.name };
});

const scKpis = getAllScKpis().map((x: any) => {
  return { id: x.id, name: x.name };
});

const referential = nbiAattributes
  .concat(nbiKpis)
  .concat(scAattributes)
  .concat(scKpis);

export function GetCommonState(
  defaultColumns: string[],
  defaultRows: string[],
  aggregatorName: string,
  requestKpi: string
): InteractiveState {
  return {
    advanceShown: false,
    aggregatorName,
    attributes: [],
    columns: defaultColumns,
    data: [],
    dateFilter: "",
    exclusions: {},
    filter: "",
    filters: [],
    jsonData: [],
    kpis: [],
    renderer: "Stacked Bar Chart",
    requestKpi,
    rows: defaultRows,
    spinnerClass: "",
    title: "Change the title here",
    yearFilter: "",
    yearTags: [],
  };
}

export function PersistConfigChange(props: IProps & IWidgetConfigurationProps) {
  if (props.userSelection && props.userSelection.config) {
    const config = JSON.parse(props.userSelection.config as string);
    const options = {
      aggregatorName: config.aggregatorName,
      colOrder: config.colOrder,
      cols: getFieldInformations(config.cols, "id"),
      exclusions: config.exclusions,
      rendererName: config.rendererName,
      rowOrder: config.rowOrder,
      rows: getFieldInformations(config.rows, "id"),
      title: config.title,
      yearFilter: config.yearFilter,
    };

    if (props.onConfigChanged) {
      props.onConfigChanged(options);
    }
  }
}

/**
 * Returns an array of fields according to what you request as field : id/name
 */
export const getFieldInformations = (
  properties: string[],
  field: string
): string[] => {
  const result: string[] = map(properties, property => {
    const propertyInfo = first(
      filter(
        referential,
        item => item.name === property || item.id === property
      )
    );
    return propertyInfo ? get(propertyInfo, field) : "";
  });
  return result.filter(elem => elem);
};
